import representantesApi from "@/app/services/representantes";

export default {
    namespaced: true,
    state: {
        representante: null,
        representantes: []
    },

    mutations: {
      listar(state, representantes) {
        state.representantes = representantes;
      },

      abrir(state, representante) {
        state.representante = representante;
      },

      salvar(state, representante) {
        state.representantes.push(representante);
      },

      atualizar(state, representante) {
        let index = state.representantes.findIndex(representante_ => representante_.id == representante.id);
        if (index > -1) {
          state.representantes.splice(index, 1, representante);
        }
      },

      excluir(state, id) {
        let index = state.representantes.findIndex(representante => representante.id == id);
        if (index > -1) {
          state.representantes.splice(index, 1);
        }
      },

      UNSET_REPRESENTANTE(state) {
        state.representante = null;
      }
    },

    actions: {
      async listar({commit}) {
        commit('LOADING_ON', null, {root: true});
        let representantes = await representantesApi.listar();
        commit('listar', representantes);
        commit('LOADING_OFF', null, {root: true});
      },

      async abrir({commit}, id) {
        commit('LOADING_ON', null, {root: true});
        let representante = await representantesApi.abrir(id);
        commit('abrir', representante);
        commit('LOADING_OFF', null, {root: true});
      },

      async salvar({commit}, representante) {
        let novorepresentante = await representantesApi.salvar(representante);
        commit('salvar', novorepresentante);
      },

      async atualizar({commit}, representante) {
        await representantesApi.atualizar(representante);
        commit('atualizar', representante);
      },

      async excluir({commit}, id) {
        await representantesApi.excluir(id);
        commit('excluir', id);
      }
    }
}
